<template>
  <div>
        <v-container fluid pa-0 class="h-100">
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="transparent" flat elevation="0">
                        <v-toolbar-title class="ml-0">Deliveries<bc-breadcrumbs :items="breadcrumb_items"></bc-breadcrumbs></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="shipment_planner.shipment_id && shipment_planner.shipment_id > 0" @invoke-method="refresh(true)"></bc-btn-refresh>
                    </v-toolbar>
                </v-layout>
            </v-container>
            <v-card elevation="0" class="h-100">
                <v-card-text style="height: calc(100vh - 145px)">
                    <v-layout row :wrap="$bp.smallScreen">
                        <v-flex xs3>
                            <v-card class="br-7" elevation="0">
                                <v-card-title class="c-border br-7 background-white" style="margin-bottom: 12px">
                                    <span class="headline">Loads</span>
                                </v-card-title>
                                <v-card-text class="pa-0" style="background-color: transparent">
                                    <vue-perfect-scrollbar style="height: calc(100vh - 300px)">
                                        <v-card
                                            v-for="(item, index) in deliveries"
                                            elevation="0"
                                            class="br-7 c-border pa-0 clickable"
                                            style="background: white !important"
                                            @click="selectDelivery(item.shipment_id)"
                                            :style="{
                                                border:
                                                    delivery.shipment_id == item.shipment_id ? '1px solid #0062d5 !important' : '1px solid #dbdcdc !important',
                                            }"
                                            :class="{
                                                'mb-2': index != deliveries.length - 1,
                                            }"
                                        >
                                            <v-card-title style="background: #fafafa" class="c-border-bottom">
                                                <!-- <v-icon size="32">hgi hgi-stroke hgi-checkmark-circle-02</v-icon> -->
                                                <span>{{ `Load #${item.shipment_id}` }}</span>
                                                <v-spacer />
                                                <v-chip small :color="item.status_class" class="ma-0 mb-2 br-7" disabled text-color="white">{{
                                                    item.status
                                                }}</v-chip>
                                            </v-card-title>
                                            <v-card-text>
                                                <small>Truck</small>
                                                <p class="mb-1" style="color: black">{{ item.vehicle_name }}</p>
                                                <small v-if="item.trailer_id">Trailer</small>
                                                <p v-if="item.trailer_id" class="mb-1" style="color: black">{{ item.trailer_name }}</p>
                                                <small>Load Date</small>
                                                <p class="mb-1" style="color: black">{{ item.load_date ? item.load_date : "N/A" }}</p>
                                                <small>Delivery Date</small>
                                                <p style="margin-bottom: 0px !important; color: black">{{ item.deliver_date ? item.deliver_date : "N/A" }}</p>
                                            </v-card-text>
                                        </v-card>
                                        <!-- <v-list two-line class="v-list--three-line-100 br-7" style="background-color: transparent">
                                            <template v-for="(item, index) in deliveries">
                                                <v-list-tile
                                                    @click="selectDelivery(item.shipment_id)"
                                                    :style="{
                                                        backgroundColor: delivery.shipment_id == item.shipment_id ? '#186dde' : 'white',
                                                        marginBottom: index == deliveries.length - 1 ? '0px' : '12px',
                                                    }"
                                                    :dark="delivery.shipment_id == item.shipment_id"
                                                    class="br-7 c-border pa-0"
                                                >
                                                    <v-list-tile-content>
                                                        <v-list-tile-title class="pa-2 br-7" style="background: #fafafa"
                                                            ><strong>{{ `Load #${item.shipment_id}` }}</strong
                                                            ><v-spacer /><v-chip
                                                                small
                                                                :color="item.status_class"
                                                                class="ma-0 mb-2 br-7"
                                                                disabled
                                                                text-color="white"
                                                                >{{ item.status }}</v-chip
                                                            ></v-list-tile-title
                                                        >
                                                        <v-list-tile-sub-title class="pa-2">
                                                            <v-divider />
                                                            <small>Truck</small>
                                                            <p class="mb-1" style="color: black">{{ item.vehicle_name }}</p>
                                                            <small v-if="item.trailer_id">Trailer</small>
                                                            <p v-if="item.trailer_id" class="mb-1" style="color: black">{{ item.trailer_name }}</p>
                                                            <small>Load Date</small>
                                                            <p class="mb-1" style="color: black">{{ item.load_date ? item.load_date : "N/A" }}</p>
                                                            <small>Delivery Date</small>
                                                            <p style="margin-bottom: 0px !important; color: black">
                                                                {{ item.deliver_date ? item.deliver_date : "N/A" }}
                                                            </p>
                                                        </v-list-tile-sub-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </template>
                                        </v-list> -->
                                  </vue-perfect-scrollbar>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-divider vertical class="mt-0 mb-0 ml-2 mr-2" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs3>
                            <v-card class="br-7" elevation="0">
                                <v-card-title class="c-border br-7 background-white" style="margin-bottom: 12px">
                                    <span class="headline">Deliveries</span>
                                    <v-spacer />
                                    <v-btn
                                        v-if="$isObjectSet(delivery)"
                                        class="ma-0 pa-0"
                                        @click="confirmRejectDialog = !confirmRejectDialog"
                                        color="error"
                                        small
                                        >Reject</v-btn
                                    >
                                    <v-btn
                                        class="ma-0 pa-0 ml-2"
                                        v-if="$isObjectSet(delivery) && delivery.status_id != 213"
                                        @click="changeStatus({ option_id: 213 })"
                                        color="success"
                                        small
                                        >Accept</v-btn
                                    >
                                </v-card-title>
                                <v-card-text v-if="delivery.deliveries" class="pa-0">
                                    <vue-perfect-scrollbar style="height: calc(100vh - 300px); z-index: 1">
                                        <v-card
                                            v-for="(location, index) in delivery.deliveries || []"
                                            :key="index"
                                            class="br-7 c-border pa-0 clickable"
                                            :style="{
                                                border:
                                                    current_delivery && current_delivery.delivery_id == location.delivery_id
                                                        ? '1px solid #0062d5 !important'
                                                        : '1px solid #dbdcdc !important',
                                                marginBottom: index == delivery.deliveries.length - 1 ? '0px' : '12px',
                                                pointerEvents: delivery.status_id != 213 ? 'none' : 'auto',
                                                background: 'white !important',
                                            }"
                                            elevation="0"
                                            @mouseup.left="selectPlanner(location.delivery_id)"
                                        >
                                            <v-card-title class="c-border-bottom" style="background: #fafafa">
                                                <span v-if="$isSet(location.ship_location_label)">{{ location.ship_location_label }}</span>
                                                <v-spacer />
                                                <v-chip class="ma-0 br-7" color="rgba(0, 0, 0, 0.08)" small text-color="black">{{
                                                    `${ordinal_suffix_of(index + 1)} Stop`
                                                }}</v-chip>
                                            </v-card-title>
                                            <v-card-text>
                                                <small>Address</small>
                                                <bc-tooltip top>
                                                    <template slot="activator">
                                                        <p
                                                            class="clickable"
                                                            @mouseup.left.stop="
                                                                $copyToClipboard(
                                                                    `${location.ship_address1 ? location.ship_address1 : ''} ${
                                                                        location.ship_address ? location.ship_address : ''
                                                                    } ${location.ship_city ? location.ship_city : ''}, ${
                                                                        location.ship_state ? location.ship_state : ''
                                                                    }, ${location.ship_zip_code ? location.ship_zip_code : ''} ${
                                                                        location.ship_country_iso_3 ? location.ship_country_iso_3 : ''
                                                                    }`
                                                                )
                                                            "
                                                        >
                                                            {{ location.ship_address1 }}
                                                            {{ location.ship_address }}
                                                            {{ location.ship_city }}, {{ location.ship_state }}, {{ location.ship_zip_code }}
                                                            {{ location.ship_country_iso_3 }}
                                                            <v-icon class="fw-light ml-1" small>hgi-stroke hgi-copy-01</v-icon>
                                                        </p>
                                                    </template>
                                                    Copy Address
                                                </bc-tooltip>

                                                <v-divider></v-divider>
                                                <small>Products</small>
                                                <p>
                                                    {{
                                                        location.delivery_details
                                                            .map((product) => `${product.product_name} (${product.quantity_shipped})`)
                                                            .join(", ")
                                                    }}
                                                </p>
                                            </v-card-text>
                                        </v-card>
                                    </vue-perfect-scrollbar>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-divider vertical class="mt-0 mb-0 ml-2 mr-2" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs6>
                            <v-card class="br-7" elevation="0">
                                <v-card-title class="c-border br-7 background-white" style="margin-bottom: 12px">
                                    <span class="headline"
                                        >Delivery<v-chip
                                            dark
                                            small
                                            class="br-7 ml-2 ma-0"
                                            v-if="$isObjectSet(current_delivery)"
                                            :color="current_delivery.status_class"
                                            >{{ current_delivery.status }}</v-chip
                                        ></span
                                    >
                                    <v-spacer />
                                    <v-btn v-if="$isObjectSet(current_delivery)" icon class="ma-0 clickable" @click="printPDF(current_delivery.delivery_id)">
                                        <v-icon>hgi-solid hgi-printer</v-icon>
                                    </v-btn>
                                    <v-btn v-if="$isObjectSet(current_delivery)" icon class="ma-0 clickable" @click="closeShipmentPlanner">
                                        <v-icon>hgi-solid hgi-cancel-01</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-card-text v-if="$isObjectSet(current_delivery)" style="background: white" class="c-border br-7">
                                    <v-layout row wrap>
                                        <v-flex xs5 xl7>
                                            <div style="display: flex; flex-direction: column; align-self: start">
                                                <span class="headline">Shipping Address</span>
                                                <strong>{{ $isSet(current_delivery.ship_location_label) ? current_delivery.ship_location_label : "" }}</strong>
                                                <span>
                                                    {{ current_delivery.ship_address1 }}
                                                    {{ current_delivery.ship_address }}
                                                    {{ current_delivery.ship_city }}, {{ current_delivery.ship_state }},
                                                    {{ current_delivery.ship_zip_code }}
                                                    {{ current_delivery.ship_country_iso_3 }}
                                                </span>
                                            </div>
                                        </v-flex>
                                        <v-flex xs7 xl5>
                                            <div style="display: flex; flex-direction: row; align-items: flex-end" class="pb-1">
                                                <small v-if="signature_saved == false">Please sign in the box below.</small>
                                                <v-spacer></v-spacer>
                                                <div style="display: flex; gap: 5px">
                                                    <v-btn class="ma-0" v-if="can_sign == false" small color="primary" @click="setupSignature">{{
                                                        signature_saved == false ? "Sign" : "Re-sign"
                                                    }}</v-btn>
                                                    <v-btn class="ma-0" v-if="can_sign == true" icon small color="success" @click="saveSignature"
                                                        ><v-icon size="18">hgi-solid hgi-floppy-disk</v-icon></v-btn
                                                    >
                                                    <v-btn
                                                        class="ma-0"
                                                        v-if="signature != null && signature_saved == false"
                                                        small
                                                        icon
                                                        color="primary"
                                                        @click="resetSignature"
                                                        ><v-icon size="18">hgi-solid hgi-restore-bin</v-icon></v-btn
                                                    >
                                                    <v-btn class="ma-0" v-if="can_sign == true" small color="error" flat @click="cancelSignature">Cancel</v-btn>
                                                </div>
                                            </div>
                                            <div style="display: flex; flex-direction: column; align-items: flex-end" class="pb-1">
                                                <VueSignaturePad
                                                    v-if="signature == null || signature_saved == false"
                                                    width="100%"
                                                    height="150px"
                                                    ref="signaturePad"
                                                    class="br-7 c-border background-white"
                                                    :options="{ onEnd }"
                                                />
                                                <img
                                                    v-if="signature != null && signature_saved == true"
                                                    :src="signature"
                                                    alt="signature"
                                                    class="c-border br-7"
                                                />
                                            </div>
                                        </v-flex>
                                        <v-flex xs12>
                                            <span class="headline">Products</span>
                                            <v-data-table :headers="headers" :items="current_delivery.delivery_details" hide-actions>
                                                <template slot="items" slot-scope="props">
                                                    <tr>
                                                        <td>{{ props.item.product_name }}</td>
                                                        <td class="text-center">{{ props.item.document_id }}</td>
                                                        <td class="text-center">{{ props.item.quantity_ordered }}</td>
                                                        <td class="text-center">{{ props.item.quantity_shipped }}</td>
                                                        <td>
                                                            <v-text-field
                                                                v-model="props.item.quantity_delivered"
                                                                :rules="ifValid('shipment_planners.shipment_planner_details.quantity_delivered')"
                                                                :disabled="shipment_planner.status_id == 6"
                                                                label="Qty"
                                                                single-line
                                                                hide-details
                                                            ></v-text-field>
                                                        </td></tr
                                                ></template>
                                            </v-data-table>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn v-if="$isObjectSet(current_delivery)" :disabled="canSave" color="success" @click="saveCurrentDelivery">{{
                                        $t("lang.save")
                                    }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

            <bc-dialog v-if="confirmRejectDialog == true" :value="confirmRejectDialog" max-width="500">
                <v-card>
                    <v-form ref="form_shipment_planner">
                        <v-card-title>
                            <span class="headline">Reject Delivery</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeConfirmRejectDialog"
                                :dialog-status="confirmRejectDialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <span class="text-center"
                                            >Rejecting a delivery will push the delivery back to Draft status and will have to re-finalized by dispatch.</span
                                        >
                                        <br />
                                        <span class="text-center">Are you sure you want to continue?</span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" @click="changeStatus({ option_id: 26 })">Reject</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>

            <delete-confirmation-dialog
                ref="delete_shipment_planner"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_shipment_planner')"
                :message="$t('lang.delete_shipment_planner_confirm')"
                @onConfirm="deleteShipmentPlanners()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_shipment_planner_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteShipmentPlannerDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { Container, Draggable } from "vue-dndrop";
import _ from "lodash";
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import { Drag, Drop, DropMask } from "vue-easy-dnd";

export default {
	components: {
		Drag,
		Drop,
		DropMask,
		Container,
		Draggable,
	},
	data() {
		return {
			breadcrumb_items: [
				{
					text: "Dashboard",
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: "dashboard",
					},
				},
				{
					text: `Deliveries`,
					disabled: true,
					href: "",
				},
			],
			mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

			formData: {},
			shipment_planner: {},
			file_name: "",
			dbGetShipmentPlanner: _.debounce(this.getShipmentPlanner, 1500, { maxWait: 1500, leading: true, trailing: false }),
			customers: null,
			tanker_truck: {},
			loads: [],
			transaction_documents: [],
			drivers: [],
			tanker_trailer: {},
			canSave: false,
			stopSave: [],
			updating_table: false,
			headers: [
				{ text: "Product", sortable: false, width: "50%" },
				{ text: "Order #", sortable: false, width: "10%", align: "center" },
				{ text: "Order Qty", sortable: false, width: "10%", align: "center" },
				{ text: "Shipped Qty", sortable: false, width: "10%", align: "center" },
				{ text: "Delivered Qty", sortable: false, width: "20%" },
			],
			sign_dialog: false,
			signature: null,
			deliveries: [],
			delivery: {},
			warehouse: {},
			shipment_planner: {},
			current_delivery: null,
			can_sign: false,
			signature_saved: false,
			previous_signature: null,
			confirmRejectDialog: false,
		};
	},
	beforeRouteUpdate(to, from, next) {
		const id = `${to.params.id}`;
		this.$store.commit("toggleMainMenu", false);
		this.refresh();
		this.finishLoader();
		next();
		if (id !== "undefined") {
		} else {
			this.finishLoader();
			next();
		}
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			const id = `${to.params.id}`;
			vm.$store.commit("toggleMainMenu", false);
			vm.refresh();
			vm.finishLoader();
			if (id !== "undefined") {
			} else {
				vm.finishLoader();
			}
		});
	},
	computed: {
		...mapState({
			rules_shipment_planners: (state) => state.shipment_planners.rules_shipment_planners,
			rules_deliveries: (state) => state.shipment_planners.rules_deliveries,
			shipment_planner_status_options: (state) => state.settings.shipment_planner_status,
			shipment_planners: (state) => state.shipment_planners.shipment_planners,
			selectedShipmentPlanner: (state) => state.shipment_planners.selectedShipmentPlanner,
			vehicles: (state) => state.vehicles.tanker_truck_options,
			selectedCustomer: (state) => state.customers.selectedCustomer,
			current_docs: (state) => state.transaction_documents.transaction_document_options,
			company_options: (state) => state.companies.company_options,
		}),
		filterTrucks() {
			return this.vehicles.length > 0
				? this.vehicles.filter((truck) => truck.company_id == this.shipment_planner.company_id && truck.vehicle_type == "truck")
				: [];
		},
		filterTrailers() {
			return this.vehicles.length > 0
				? this.vehicles.filter((truck) => truck.company_id == this.shipment_planner.company_id && truck.vehicle_type == "trailer")
				: [];
		},
		checkTruckCompartments() {
			let truck = this.vehicles.find((truck) => truck.truck_id == this.shipment_planner.truck_id);
			return truck != undefined && truck.num_of_compartments > 0 ? false : true;
		},
		checkTrailerCompartments() {
			return this.vehicles.length > 0 ? this.vehicles.find((truck) => truck.truck_id == this.shipment_planner.trailer_id) : [];
		},
	},
	methods: {
		...mapActions([
			"fetchShipmentPlanner",
			"saveShipmentPlanner",
			"deleteShipmentPlanner",
			"printShipmentPlanner",
			"fetchTankerTrucks",
			"fetchTransactionDocuments",
			"fetchCustomer",
			"validationOn",
			"fetchCompanies",
			"fetchPeople",
			"fetchShipmentPlanners",
			"fetchWarehouse",
			"fetchShipmentPlannerDeliveries",
			"fetchDelivery",
			"saveDelivery",
			"printShipmentDelivery",
		]),
		...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
		getShipmentPlanner(pg_refresh = false) {
			this.startLoader();

			this.fetchShipmentPlanner({
				id: `${this.$route.params.id}`,
			}).then((data) => {
				if (typeof data !== "undefined" && data.shipment_planner) {
					this.shipment_planner = this.assignObj2(data.shipment_planner, this.rules_shipment_planners);
					this.toggleModalLoader(false);
					this.validationOff();
					this.finishLoader(pg_refresh);
				}
			});
		},
		printPDF(delivery_id) {
			this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

			this.printShipmentDelivery({
				id: delivery_id,
			}).then((data) => {
				if (typeof data != "undefined" && data.delivery) {
					if (this.dev_mode) {
						this.file_name = data.delivery.file_name;
					} else {
						this.$refs.print.printReport(data.delivery.file_name);
					}

					if (!this.dev_mode) this.toggleGlobalSnackbar(false);
				} else {
					this.file_name = "";
					this.$refs.print.close();
					this.createAlert();
				}
			});
		},
		saveShipmentPlanners() {
			this.validationOn();
			this.$nextTick(() => {
				let body = this.prepForm(this.shipment_planner, this.rules_shipment_planners);

				this.saveShipmentPlanner({
					body: body,
				}).then((data) => {
					if (typeof data != "undefined" && data.shipment_planner) {
						this.shipment_planner = this.assignObj2(data.shipment_planner, this.rules_shipment_planners);
						if (this.shipment_planner.shipment_planner_details == null) this.shipment_planner.shipment_planner_details = [];
						this.sign_dialog = false;
						this.validationOff();
					} else {
					}
				});
			});
		},
		changeStatus(item) {
			this.status_loader = true;
			let body = { shipment_id: `${this.delivery.shipment_id}`, status_id: item.option_id };

			this.saveShipmentPlanner({
				body: body,
			}).then((data) => {
				if (typeof data != "undefined" && data.shipment_planner) {
					if (item.option_id == 26) {
						this.delivery = {};
						this.current_delivery = {};
						this.confirmRejectDialog = false;
					} else {
						this.selectDelivery(this.delivery.shipment_id);
					}
					this.fetchShipmentPlanners({ body: { options: 1, status: [212, 213] } }).then((data) => {
						if (typeof data !== "undefined" && data.shipment_planners) {
							this.deliveries = data.shipment_planners || [];
						}
					});
				}
			});
		},
		deleteShipmentPlanners() {
			this.deleteShipmentPlanner({
				id: `${this.$route.params.id}`,
			}).then((data) => {
				if (data && data.code == "200") {
					this.validationOff();
					this.$router.push({ name: "shipment_planners" });
				}
				this.toggleModalLoader(false);
			});
		},
		range(min, max) {
			var array = [],
				j = 0;
			for (var i = min; i <= max; i++) {
				array[j] = i;
				j++;
			}
			return array;
		},
		getDrivers(company_id) {
			this.fetchPeople({ body: { options: 1, company_id: company_id } }).then((data) => {
				if (typeof data !== "undefined" && data.people) {
					this.drivers = data.people;

					if (this.shipment_planner.driver_id) {
						this.shipment_planner.driver_id = this.drivers.find((driver) => driver.people_id == this.shipment_planner.driver_id).people_id;
					}
				}
			});
		},
		saveSignature() {
			this.signature = this.$refs.signaturePad.saveSignature().data;
			if (this.$isSet(this.signature)) {
				this.sign_dialog = false;
				this.signature_saved = true;
				this.can_sign = false;
				this.current_delivery.signature = this.signature;

				let body = this.prepForm(this.current_delivery, this.rules_deliveries);
				this.saveDelivery({ body: body, id: this.current_delivery.delivery_id }).then((data) => {
					if (typeof data !== "undefined" && data.deliveries) {
						this.current_delivery = data.deliveries;

						if (this.$isSet(this.current_delivery.signature)) {
							this.signature = this.current_delivery.signature;
							this.sign_dialog = false;
							this.signature_saved = true;
							this.can_sign = false;
							delete this.current_delivery.signature;
						}
					}
				});
			}
		},
		async refresh(force = false) {
			this.startLoader();

			if (force == true) {
				await this.fetchShipmentPlanner({
					id: `${this.$route.params.id}`,
					body: {
						by_order: 1,
					},
				}).then((data) => {
					if (typeof data !== "undefined" && data.shipment_planner) {
						this.shipment_planner = this.assignObj2(data.shipment_planner, this.rules_shipment_planners);
						this.toggleModalLoader(false);
						this.validationOff();
						this.finishLoader(true);
					}
				});
			} else {
				this.finishLoader();
			}

			if (this.vehicles.length == 0 || force == true) {
				await this.fetchTankerTrucks({ body: { options: 1 } }).then((data) => {
					if (typeof data !== "undefined" && data.vehicles) {
						this.tanker_truck = this.vehicles.find((truck) => truck.truck_id == this.shipment_planner.truck_id);
						this.tanker_trailer = this.vehicles.find((truck) => truck.truck_id == this.shipment_planner.trailer_id);
					}
				});
			} else {
				this.tanker_truck = this.vehicles.find((truck) => truck.truck_id == this.shipment_planner.truck_id);
				this.tanker_trailer = this.vehicles.find((truck) => truck.truck_id == this.shipment_planner.trailer_id);
			}

			if (this.transaction_documents.length == 0 || force == true) {
				await this.fetchTransactionDocuments({ body: { company_id: this.shipment_planner.company_id, status: "open", options: 1 } }).then((data) => {
					if (typeof data !== "undefined" && data.transaction_documents) {
						this.transaction_documents = JSON.parse(JSON.stringify(data.transaction_documents));
					}
				});
			}

			if (this.shipment_planner.company_id) {
				this.fetchCustomer({
					id: this.shipment_planner.company_id,
				});
			}

			if (this.company_options.length == 0 || force == true) await this.fetchCompanies({ body: { options: 1 } });

			if (this.drivers.length == 0 || force == true) {
				this.getDrivers(this.shipment_planner.company_id);
			}

			this.fetchShipmentPlanners({ body: { options: 1, status: [212, 213] } }).then((data) => {
				if (typeof data !== "undefined" && data.shipment_planners) {
					this.deliveries = data.shipment_planners;
				}
			});
		},
		closeSignDialog() {
			this.sign_dialog = false;
			this.validationOff();
			this.toggleModalLoader(false);
		},
		formatNumberWithCommas(number) {
			return number.toLocaleString("en-US");
		},
		changeTrailer() {
			if (this.vehicles.filter((truck) => truck.truck_id == this.shipment_planner.truck_id)[0].num_of_compartments > 0) {
				this.shipment_planner.trailer_id = null;
			}
		},
		indexRoute() {
			let index = 0;
			this.shipment_planner.shipment_planner_details.forEach((item) => {
				item.route_order = index;
				index++;
			});
		},
		selectDelivery(delivery_id) {
			this.fetchShipmentPlannerDeliveries({
				id: delivery_id,
			}).then((data) => {
				if (typeof data !== "undefined" && data.shipment_planner) {
					this.delivery = this.assignObj2(data.shipment_planner, this.rules_shipment_planners);
					if (this.delivery.delivery_details == null) this.delivery.delivery_details = [];
					this.fetchWarehouse({ id: this.delivery.warehouse_id }).then((data) => {
						if (typeof data !== "undefined" && data.warehouse) {
							this.warehouse = data.warehouse;
						}
					});
				} else {
					next({ name: "shipment_planners", replace: true });
				}
			});
		},
		selectPlanner(delivery_id) {
			this.fetchDelivery({
				id: delivery_id,
			}).then((data) => {
				if (typeof data !== "undefined" && data.deliveries) {
					this.current_delivery = data.deliveries;

					if (this.$isSet(this.current_delivery.signature)) {
						this.signature = this.current_delivery.signature;
						this.sign_dialog = false;
						this.signature_saved = true;
						this.can_sign = false;
						delete this.current_delivery.signature;
					}
				}
			});
		},
		ordinal_suffix_of(i) {
			var j = i % 10,
				k = i % 100;
			if (j == 1 && k != 11) {
				return i + "st";
			}
			if (j == 2 && k != 12) {
				return i + "nd";
			}
			if (j == 3 && k != 13) {
				return i + "rd";
			}
			return i + "th";
		},
		onEnd() {
			this.signature = this.$refs.signaturePad.saveSignature().data;
		},
		resetSignature() {
			this.signature = null;
			this.$refs.signaturePad.clearSignature();
		},
		setupSignature() {
			if (this.signature != null) {
				this.previous_signature = this.signature;
			}
			this.signature = null;

			this.can_sign = true;
			this.signature_saved = false;
			this.$nextTick(() => {
				this.$refs.signaturePad.openSignaturePad();
			});
		},
		cancelSignature() {
			if (this.previous_signature != null) {
				this.signature = this.previous_signature;
				this.signature_saved = true;
			} else {
				this.signature = null;
				this.signature_saved = false;
			}

			this.can_sign = false;
			this.$refs.signaturePad.clearSignature();
			this.$refs.signaturePad.lockSignaturePad();
		},
		closeShipmentPlanner() {
			this.current_delivery = null;
		},
		saveCurrentDelivery() {
			this.validationOn();
			this.$nextTick(() => {
				let body = this.prepForm(this.current_delivery, this.rules_deliveries);

				this.saveDelivery({
					body: body,
					id: this.current_delivery.delivery_id,
				}).then((data) => {
					if (typeof data !== "undefined" && data.deliveries) {
						this.current_delivery = data.deliveries;
						this.validationOff();

						if (this.$isSet(this.current_delivery.signature)) {
							this.signature = this.current_delivery.signature;
							this.sign_dialog = false;
							this.signature_saved = true;
							this.can_sign = false;
							delete this.current_delivery.signature;
						}
					}
				});
			});
		},
		closeConfirmRejectDialog() {
			this.confirmRejectDialog = false;
		},
	},
	created() {},
};
</script>
<style>
.mask {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	border: 1px solid black;
	background-color: rgba(255, 0, 0, 0.2);
	width: 200px;
	height: 100px;
}

.mask::before {
	content: "MASK";
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	color: rgba(0, 0, 0, 0.4);
	font-size: 25px;
	font-weight: bold;
}

.drop-allowed {
	background-color: rgba(0, 255, 0, 0.2);
}

.drop-forbidden {
	background-color: rgba(255, 0, 0, 0.2);
}

.drop-in {
	box-shadow: 0 0 5px rgba(0, 0, 255, 0.4);
}

.list-enter,
.list-leave-to {
	opacity: 0;
}

.list-leave-active {
	position: absolute;
}

.small-text-field.v-text-field--outline > .v-input__control > .v-input__slot {
	min-height: 28px !important;
	background-color: white !important;
	padding: 0 4px !important;
}

.small-text-field.v-text-field--outline input {
	margin-top: 0px !important;
	background-color: white !important;
	text-align: left;
}

.red-color {
	color: red !important;
}

.white-color {
	color: white !important;
}
.v-list--three-line-100 .v-list__tile {
	height: 100% !important;
}
.h-pre-line {
	white-space: pre-line !important;
}
</style>
